"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";
import { logout } from "@/app/actions";
import { useQueryClient } from "@tanstack/react-query";
import pb from "@/lib/pocketbase";

const ListNavigation = () => {
  const pathname = usePathname();
  const queryClient = useQueryClient();

    const handleLogout = async () => {
    await logout();
    pb.authStore.clear();
    queryClient.invalidateQueries({ queryKey: ["user"] });
    queryClient.clear();
  };

  const navItems = [
    { text: "My Account", href: "/account/profile" },
    { text: "My Adverts", href: "/account/my-adverts" },
    { text: "Favourite adverts", href: "/account/favourite-adverts" },
    { text: "Saved Search alerts", href: "/account/saved-searches" },
    { text: "Contact us", href: "/contact" },
  ];

  return (
    <nav>
      <ul className="space-y-2">
        {navItems.map((item, index) => (
          <li key={index}>
            <Link
              href={item.href}
              className={`${
                pathname === item.href
                  ? "text-primary font-semibold"
                  : "text-base-content/70"
              }`}
            >
              {item.text}
            </Link>
          </li>
        ))}
        <li>
          <button
            onClick={handleLogout}
            className="text-base-content/70"
          >
            Log out
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default ListNavigation;
